import { COLOR1, COLOR2 } from '../../../constants';

export const AddressInformationStyles = {
  contact_stepper: {
    width: '100%',
    margin: '37px 30px 40px 50px',
    '@media (max-width:960px)': {
      margin: '37px 50px 45px 50px',
    },
    '@media (max-width:650px)': {
      margin: '25px',
    },
  },
  homeAddGrid: {
    '@media (min-width:600px)': {
      paddingRight: '20px',
    },
    '@media (max-width:960px)': {
      paddingRight: 0,
      order: 2,
    },
  },
  mailAddGrid: {
    '@media (min-width:600px)': {
      paddingRight: '20px',
    },
    '@media (max-width:960px)': {
      paddingRight: 0,
    },
  },
  docUploadSidebarGrid: {
    '@media (max-width:960px)': {
      order: 1,
    },
  },
  address_info_grid_margin: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
    borderRadius: '6px',
    paddingTop: '30px',
    paddingRight: '30px',
    paddingBottom: '30px',
    paddingLeft: '30px',
    '@media (max-width:600px)': {
      border: 'none',
      boxShadow: 'none',
      borderRadius: 0,
      marginTop: '-30px',
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  },
  id_upload_module_grid: {
    marginTop: '60px',
    '@media (min-width:959px) and (max-width:1300px)': {
      paddingLeft: '20px',
    },
    '@media (max-width:600px)': {
      marginTop: '23px',
    },
  },
  togglePadding: {
    marginLeft: '15px',
    '@media (max-width:470px)': {
      marginLeft: 0,
    },
  },
  horizontal_line: {
    background: '#D0D0D0',
    margin: '30px 0px',
    '@media (max-width:600px)': {
      margin: '20px 0px',
    },
  },
  input_grid_addr: {
    marginTop: '20px',
    '@media (max-width:600px)': {
      marginTop: '20px',
    },
  },
  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },
  mailing_address_box: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    '@media (max-width:470px)': {
      display: 'block',
    },
  },
  mailing_address_text: {
    textAlign: 'left',
    font: 'normal 400 16px/18px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    marginRight: '25px',
    '@media (max-width:600px)': {
      font: 'normal normal 400 16px/18px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      opacity: 1,
    },
  },
  same_mail_checkbox_margins: {
    marginTop: '20px',
    '@media (max-width:650px)': {
      marginTop: '25px',
    },
  },
  checkbox_label_style: {
    marginLeft: '2px',
    textAlign: 'left',
    font: 'normal normal 300 16px/18px Arial',
    letterSpacing: '0.11px',
    color: COLOR1,
    opacity: 1,
  },
  checkbox_content_position: {
    display: 'block',
    position: 'relative',
    top: '-20px',
    left: '32px',
    width: 'fit-content',
    marginRight: '30px',
    '@media (max-width:600px)': {
      top: '-18px',
      left: '27px',
    },
  },
  address_button_container: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
    borderRadius: '6px',
    padding: '30px',
    opacity: 1,
    '@media (max-width:599px)': {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      border: 'none',
      boxShadow: 'none',
      borderRadius: '0px',
      padding: 0,
    },
  },
  container_style: {
    height: 'fit-content',
  },
};

export const formHeadingInfo = {
  textAlign: 'left',
  width: 'fit-content',
  font: 'normal 700 24px/28px Arial',
  letterSpacing: '0.14px',
  color: COLOR1,
  opacity: 1,
  '@media (max-width:650px)': {
    font: 'normal normal 700 22px/32px Arial',
    letterSpacing: '0.11px',
    color: COLOR1,
    margin: '0',
    marginBottom: '5px',
  },
};
